import { render, staticRenderFns } from "./ProjectOverviewBody.vue?vue&type=template&id=23e02f50&scoped=true&"
import script from "./ProjectOverviewBody.vue?vue&type=script&lang=js&"
export * from "./ProjectOverviewBody.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOverviewBody.vue?vue&type=style&index=0&id=23e02f50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e02f50",
  null
  
)

export default component.exports